var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmInviteFurniture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77729 8.61719C3.24879 8.61719 3.70097 8.80459 4.03437 9.13817C4.36777 9.47175 4.55507 9.92419 4.55507 10.3959V12.1747H13.444V10.3959C13.444 9.92419 13.6313 9.47175 13.9647 9.13817C14.2981 8.80459 14.7502 8.61719 15.2217 8.61719C15.6932 8.61719 16.1454 8.80459 16.4788 9.13817C16.8122 9.47175 16.9995 9.92419 16.9995 10.3959V13.9535C16.9995 14.4252 16.8122 14.8776 16.4788 15.2112C16.1454 15.5448 15.6932 15.7322 15.2217 15.7322H2.77729C2.30579 15.7322 1.85361 15.5448 1.52021 15.2112C1.18681 14.8776 0.999512 14.4252 0.999512 13.9535V10.3959C0.999512 9.92419 1.18681 9.47175 1.52021 9.13817C1.85361 8.80459 2.30579 8.61719 2.77729 8.61719Z",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77734 8.61502V4.16813C2.77734 3.4605 3.0583 2.78185 3.55839 2.28148C4.05849 1.78111 4.73677 1.5 5.44401 1.5H12.5551C13.2624 1.5 13.9406 1.78111 14.4407 2.28148C14.9408 2.78185 15.2218 3.4605 15.2218 4.16813V8.61502",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66626 15.7227V17.5004",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3311 15.7227V17.5004",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmInviteFurniture);
export default __webpack_public_path__ + "static/media/crm-invite-furniture.e06e9d8eb75579c2866231d7de45e432.svg";
export { ForwardRef as ReactComponent };